import { create } from 'zustand';

type PhoneBlockSaleStore = {
  phoneBlock: boolean;
  setPhoneBlock(value: boolean): void;
};

export const usePhoneBlockSaleStore = create<PhoneBlockSaleStore>((set) => ({
  phoneBlock: false,
  setPhoneBlock(value: boolean) {
    set((state) => ({ ...state, phoneBlock: value }));
  },
}));
